import config from "../conf/config.js";
import store from "../../../store/index";
import axios from 'axios';

let getUserInfo = function(){
    let sessionid = window.localStorage.getItem("sessionid")
    let type = "pc"
    // axios({
    //     method:'post',
    //     url:config.baseApi + "/get_sns_user_info",
    //     changeOrigin: true,
    //     headers: {
    //           'Content-Type': 'application/json;charset=utf8',
    //           'token':sessionid
    //       },
    //     data:JSON.stringify({
    //         access_token:store.state.user.access_token,
    //         openid:store.state.user.openid,
    //         type:type
    //     })
    // }).then(function (res) {
    //     if(res.data.code == 1){
    //         localStorage['nickname']=res.data.data.nickname;
    //         localStorage['headimgurl']=res.data.data.headimgurl;
    //     }
    // });
    axios({
        method:'post',
        url:config.baseApi + "/account/wx/info",
        changeOrigin: true,
        headers: {
            'Content-Type': 'application/json;charset=utf8',
            'token':sessionid
        },
    }).then(function (res) {
        if(res.data.code == 1){
            console.log(res)
            localStorage['nickname']=res.data.data.realName;
            localStorage['headimgurl']=res.data.data.headImg;
            localStorage['companyName2'] = res.data.data.childCompanyName; //子公司
            localStorage['departmentName'] = res.data.data.departmentName;
            // localStorage['limitLoginTime'] = res.data.data.limitLoginTime;
            let time1 = res.data.data.limitLoginTime
            let time = new Date(time1)
            let year = time.getFullYear()
		    let month = time.getMonth()+1
		    let day = time.getDate()
            let limitLoginTime = year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day)
            localStorage['limitLoginTime'] = limitLoginTime
        }
    });
    axios({
        method:'post',
        url:config.baseApi + "/account/company/wx",
        changeOrigin: true,
        headers: {
            'Content-Type': 'application/json;charset=utf8',
            'token':sessionid
        },
    }).then(function (res) {
        if(res.data.code == 1){
            let companyName = res.data.data.companyName;
            let logo = res.data.data.logo;
            if(companyName){
                localStorage['companyName']=companyName;
            }
            if(logo){
                localStorage['logo']=logo;
            }else{
                localStorage['logo']="";
            }
        }
    });
}
export default getUserInfo;